export const GENERIC_IT_MESSAGE =
  "שגיאה כללית, במידה והתקלה ממשיכה יש לפנות למחלקת התקשוב";

export const NETWORK_ERROR_MESSAGE =
  "לא ניתן להתחבר לשרת. בדוק את חיבור האינטרנט ונסה שוב.";

export const MESSAGES = {
  FILE_TOO_LARGE: (maxMb: number) =>
    `הקובץ גדול מדי. גודל מקסימלי: ${maxMb}MB`,
  FILE_TYPE_UNSUPPORTED:
    "סוג קובץ לא נתמך. אנא העלה קובץ PDF או תמונה (JPG, PNG)",
  ANALYZE_FAILED: "נכשל בניתוח גיליון הציונים. נסה שוב או העלה קובץ אחר.",
  SUBMIT_FAILED: "נכשל בשליחת הבקשה. נסה שוב.",
  TRACK_CONFIG_FAILED:
    "לא ניתן לטעון את הגדרות המסלולים. נסה לרענן את העמוד.",
} as const;

export const MAX_UPLOAD_BYTES = 20 * 1024 * 1024;

const SUPPORTED_FILE_PATTERN = /\.(pdf|jpe?g|png)$/i;

export function isSupportedTranscriptFile(
  fileName: string,
  mimeType?: string,
): boolean {
  if (SUPPORTED_FILE_PATTERN.test(fileName)) return true;
  if (!mimeType) return false;
  return (
    mimeType === "application/pdf" ||
    mimeType === "image/jpeg" ||
    mimeType === "image/png"
  );
}

function fallbackForStatus(status: number): string | null {
  switch (status) {
    case 400:
      return "הבקשה אינה תקינה. בדוק את הנתונים ונסה שוב.";
    case 401:
    case 403:
      return GENERIC_IT_MESSAGE;
    case 404:
      return "השירות המבוקש לא נמצא. נסה לרענן את העמוד.";
    case 413:
      return MESSAGES.FILE_TOO_LARGE(20);
    case 422:
      return null;
    case 429:
      return "בוצעו יותר מדי בקשות. המתן מספר שניות ונסה שוב.";
    case 503:
      return "השירות אינו זמין כרגע. נסה שוב בעוד מספר דקות.";
    case 504:
      return "הבקשה ארכה זמן רב מדי. נסה שוב.";
    default:
      return null;
  }
}

export async function readApiError(
  response: Response,
  fallback: string,
): Promise<string> {
  const text = await response.text().catch(() => "");

  if (text) {
    try {
      const data = JSON.parse(text) as { error?: unknown };
      if (typeof data.error === "string" && data.error.trim()) {
        return data.error.trim();
      }
    } catch {
      const trimmed = text.trim();
      if (trimmed && trimmed.length <= 300 && !trimmed.startsWith("<")) {
        return trimmed;
      }
    }
  }

  return fallbackForStatus(response.status) ?? fallback;
}

export function isNetworkError(err: unknown): boolean {
  return (
    err instanceof TypeError &&
    (err.message === "Failed to fetch" || err.message.includes("NetworkError"))
  );
}

export function getErrorMessage(
  err: unknown,
  fallback = GENERIC_IT_MESSAGE,
): string {
  if (isNetworkError(err)) return NETWORK_ERROR_MESSAGE;

  if (err instanceof Error) {
    const message = err.message.trim();
    if (message) return message;
  }

  return fallback;
}
